import { operations } from '../../store/conversations';
import selectConversation from './selectConversation.action';

const createConversationWithOneUser =
  (user, { source } = {}) =>
  async (dispatch) => {
    const { objectId: conversationId } = await dispatch(
      operations.createConversation({
        title: '-',
        users: [user],
      })
    );
    return dispatch(selectConversation(conversationId, source));
  };

export default createConversationWithOneUser;
